import React from 'react'

import Box from '@material-ui/core/Box';

import Header from './Header';
import Player from './Player';
import ShareButton from './ShareButton';

import IViewQueryParams from './IViewQueryParams';

import TagManager from 'react-gtm-module';

const tagManagerArgs = {
  gtmId: 'GTM-NV67WG6'
}

TagManager.initialize(tagManagerArgs)

interface Props {
  queryParams: IViewQueryParams;
}

interface State {
}

const onViewVideo = () => {
  (window as any).dataLayer.push({ 'event': 'screen-recording-view' });
};

class RecorderView extends React.Component<Props> {

  componentDidMount() {
    onViewVideo();
  }

  render() {

    return (
      <Box
        bgcolor="common.white"
      >
        {!this.props.queryParams.edit &&
          <Header />
        }
        {this.props.queryParams.edit &&
          <ShareButton
            queryParams={this.props.queryParams}
          />
        }
        <Player
          queryParams={this.props.queryParams}
        />
      </Box>
    );
  }

}

export default RecorderView;  